"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["Bahasa", "Cantonese (Chinese)", "English", "French", "German", "Italian", "Japanese", "Korean", "Mandarin (Chinese)", "Other", "Portuguese", "Russian", "Spanish"];
exports.default = _default;
//# sourceMappingURL=preferred_language.js.map